import { render, staticRenderFns } from "./ReviewYourAnswersPPM.vue?vue&type=template&id=22f6634c"
import script from "./ReviewYourAnswersPPM.vue?vue&type=script&lang=ts"
export * from "./ReviewYourAnswersPPM.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports